<template>
    <rkm-modal
        :loading="loading"
        hide-footer
        ref="RkmModal"
        title="Selecione o local"
    >
        <rkm-form ref="RkmForm">
            <rkm-row 
                class="text-center" 
                style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px; justify-items: center;
                align-items: center;"
            >
                <rkm-col
                    v-for="sala in salas"
                    v-bind:key="sala.id"
                    style="flex: 1 1 190px; max-width: 190px;"
                >
                    <rkm-button
                        @click="store(sala.id)"
                        block
                        class="big-button"
                        color="primary"
                        style="margin-bottom: 5px; white-space: normal; height: 65px;"
                    >
                        {{ sala.nome }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
    },
    created() {
        this.repositories = {
            chamada: this.getConectaSusRepository('ambulatorio.chamada')
        }
    },
    data: () => ({
        filaId: null,
        telaId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(filaId, telaId) {
            this.filaId = filaId
            this.telaId = telaId

            this.$refs.RkmModal.show()
        },
        store(salaId) {
            const request = {
                filaId: this.filaId,
                telaId: this.telaId,
                salaId: salaId,
            }

            this.setLoading()

            this.repositories.chamada.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => this.close())
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        salas: {type: Array, required: true},
    },
}
</script>
